import { render, staticRenderFns } from "./UserPaymentSuccess.vue?vue&type=template&id=372cedd9&scoped=true&"
import script from "./UserPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./UserPaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./UserPaymentSuccess.vue?vue&type=style&index=0&id=372cedd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372cedd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
